<template>
  <header class="tcc-header">
    <button v-on:click="skipToContent" class="skip-to-content">Skip to content</button>
<!--    <div class="tcc-header__cookies" v-if="isShownCookiesNot">-->
<!--      <div class="tcc-header__cookies&#45;&#45;container">-->
<!--        <div class="tcc-header__cookies&#45;&#45;content">-->
<!--          This website uses cookies, so we can improve your experience here.-->
<!--          By continuing to browse the site, you are agreeing to our use of cookies.-->
<!--          Read more about this in our-->
<!--          <router-link :to="{name: 'cookies'}">Cookies Policy</router-link>-->
<!--        </div>-->
<!--        <button type="button" class="tcc-header__cookies&#45;&#45;button" @click="setCookiesPermission">I agree</button>-->
<!--      </div>-->
<!--    </div>-->
    <div class="tcc-header__inner">
      <div class="tcc-header__container">
        <router-link to="/" title="The Clear Company logo"
                     class="tcc-header__logo"
                     v-bind:style="{backgroundImage: this.customLogo ? 'url(' + getFullServerPath(this.customLogo) + ')' : '' }"
                     :class="this.customLogo ? 'industry-logo' : ''">
        </router-link>
        <ul class="tcc-header__menu" v-if="!getDeviceType('mobile') && !getDeviceType('tablet')">
          <li>
            <router-link :to="{name: 'home', hash: '#features'}">Features</router-link>
          </li>
          <li>
            <router-link :to="{name: 'home', hash: '#our-clients'}">Our clients</router-link>
          </li>
          <li class="separator">
            <router-link :to="{name: 'home', hash: '#pricing'}">Pricing</router-link>
          </li>
          <li v-for="item in headerData">
            <router-link :to="routeName(item.url)" :title="item.alt">{{ item.title }}</router-link>
          </li>
        </ul>
        <button class="tcc-header__menu--trigger"
                v-bind:aria-expanded="mobileMenuShown"
                aria-controls="mobileMenuContainer"
                @click.prevent.stop="mobileMenuShown = !mobileMenuShown"
                v-if="getDeviceType('mobile') || getDeviceType('tablet')">
          <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="bars" class="svg-inline--fa fa-bars" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path fill="currentColor" d="M424 392H23.1C10.8 392 0 402.8 0 415.1C0 429.2 10.8 440 23.1 440H424c13.2 0 24-10.8 24-23.1C448 402.8 437.2 392 424 392zM424 72H23.1C10.8 72 0 82.8 0 95.1S10.8 120 23.1 120H424c13.2 0 24-10.8 24-23.1S437.2 72 424 72zM424 232H23.1C10.8 232 0 242.8 0 256c0 13.2 10.8 24 23.1 24H424C437.2 280 448 269.2 448 256S437.2 232 424 232z"></path>
          </svg>
          <span>Menu</span>
          <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="chevron-down" class="svg-inline--fa fa-chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path fill="currentColor" d="M432.6 209.3l-191.1 183.1C235.1 397.8 229.1 400 224 400s-11.97-2.219-16.59-6.688L15.41 209.3C5.814 200.2 5.502 184.1 14.69 175.4c9.125-9.625 24.38-9.938 33.91-.7187L224 342.8l175.4-168c9.5-9.219 24.78-8.906 33.91 .7187C442.5 184.1 442.2 200.2 432.6 209.3z"></path>
          </svg>
        </button>
        <div class="tcc-header__mobile-menu"
             ref="mobileMenuContainer"
             id="mobileMenuContainer"
             v-bind:aria-expanded="mobileMenuShown"
             v-if="mobileMenuShown && (getDeviceType('mobile') || getDeviceType('tablet'))">
          <div class="tcc-header__mobile-menu--inner">
            <ul class="tcc-header__mobile-menu--list">
              <li v-for="item in headerData">
                <router-link :to="routeName(item.url)" :title="item.alt">{{ item.title }}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import api from '@/api'

export default {
  name: 'authorization-header',
  data () {
    return {
      isShownCookiesNot: false,
      mobileMenuShown: false,
      windowWidth: window.innerWidth,
      headerData: [
        {
          title: '',
          url: '',
          alt: ''
        }
      ],
      customLogo: false
    }
  },
  computed: {
    ...mapGetters([])
  },
  methods: {
    ...mapActions([]),
    getFullServerPath (fileName) {
      return api.serverContenImages + fileName
    },
    getHeaderData () {
      let self = this
      let body = {
        slug: 'landing-header'
      }
      Promise.all([
        this.$http.post(api.URLS.staticpage + '/landing-header', body, api.headersAuthSettings)
      ]).then(function (data) {
        self.headerData = JSON.parse(data[0].data.body)
      })
    },
    getIndustryLogo () {
      let industryId = localStorage.getItem('userIndustry')
      if (!industryId) {
        return
      }
      let data = {
        id: industryId
      }
      this.$http.post(api.URLS.industry + '/logo', data, api.headersAuthSettings).then((res) => {
        this.customLogo = res.body.logo
      }).catch((err) => {
        console.log(err)
      })
    },
    setCookiesPermission () {
      this.setCookie('useCookies', true, {expires: new Date(2030, 0, 0)})
      this.isShownCookiesNot = false
    },
    setCookie (name, value, options) {
      options = options || {}
      let expires = options.expires
      if (typeof expires === 'number' && expires) {
        let d = new Date()
        d.setTime(d.getTime() + expires * 1000)
        expires = options.expires = d
      }
      if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString()
      }
      value = encodeURIComponent(value)
      let updatedCookie = name + '=' + value
      for (let propName in options) {
        updatedCookie += ';' + propName
        let propValue = options[propName]
        if (propValue !== true) {
          updatedCookie += '=' + propValue
        }
      }
      document.cookie = updatedCookie
    },
    getCookie (name) {
      let matches = document.cookie.match(new RegExp(
        '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
      ))
      return matches ? decodeURIComponent(matches[1]) : undefined
    },
    handleWindowResize (event) {
      this.windowWidth = event.currentTarget.innerWidth
    },
    getDeviceType (check) {
      let width = this.windowWidth
      let deviceName = ''
      if (width > 1024) {
        deviceName = 'desktop'
      } else if (width > 600) {
        deviceName = 'tablet'
      } else {
        deviceName = 'mobile'
      }
      return check === deviceName
    },
    skipToContent: function (event) {
      event.preventDefault()
      const elm = document.getElementsByTagName('h1')[0]
      if (!elm) {
        return
      }
      elm.setAttribute('tabindex', '-1')
      elm.focus()
      this.scrollTo(document.body, elm, elm.offsetTop - 20, 1500)
    },
    scrollTo (element, target, to, duration) {
      if (duration <= 0) {
        return
      }
      const difference = to - element.scrollTop
      const perTick = difference / duration * 10
      setTimeout(function () {
        element.scrollTop = element.scrollTop + perTick
        if (element.scrollTop === to) {
          return
        }
        this.scrollTo(element, to, duration - 10)
      }, 20)
      target.focus({preventScroll: true})
    },
    routeName (link) {
      return (link || '/').replace(location.origin, '')
    }
  },
  created () {
    this.isShownCookiesNot = !this.getCookie('useCookies')
  },
  beforeMount () {
    this.getHeaderData()
    this.getIndustryLogo()
  },
  mounted () {
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  watch: {}
}
</script>

<style src="@/assets/scss/components/subscriptions/not-logged-in-header.scss" lang="scss" scoped />



// WEBPACK FOOTER //
// AuthorizationHeader.vue?60a2b34e